module.exports = __webpack_public_path__ + "images/binding-state-icon.edee5e6db0b3b5f076e572180a963aa1.png";